import React, {useEffect, useContext, useState} from 'react'
import ComponentSelector from '../ComponentSelector'
import {Grid} from '@material-ui/core/'
import {useRequiredHook, checkToDisable} from '../../utils/customHooks'
import get from 'get-value'
import _ from 'lodash'

export const FormContext = React.createContext()

const FormBuilder = props => {
    return (
        <FormContext.Provider
            value={{
                formData: props.formData,
                errors: props.errorsData || {},
                updateFormData: props.setFormData,
                updateValidation: props.updateValidation || {},
                actionMethods: props.actionMethods || (() => {}),
                toHide: props.toHide || {},
                internalCheckToShow: props.internalCheckToShow || (() => {}),
                validateForKey: props.validateForKey || (() => {}),
                setFormDataChanged: props.setFormDataChanged || (() => {}),
                validationData: props.validationData || {},
                updateErrorData: props.updateErrorData || (() => {}),
                editMode: props.editMode,
            }}
        >
            <Grid
                container
                spacing={3}
                className={`App form-main__container ${props.cssClass}`}
            >
                {props.fields.map((compProps, index) => {
                    return <FormFieldWrapper key={index} {...compProps} />
                })}
            </Grid>
        </FormContext.Provider>
    )
}

export const FormFieldWrapper = props => {
    const {
        formData,
        updateFormData,
        errors,
        updateValidation,
        actionMethods,
        toHide,
        internalCheckToShow,
        validateForKey,
        setFormDataChanged,
        validationData,
        updateErrorData,
        editMode,
    } = useContext(FormContext)
    const [toShow, setToShow] = useState(true)
    const [isDisable, setIsDisable] = useState(props.isDisable || false)
    const [validateOnBlur, setValidateOnBlur] = useState(false)
    const {required} = useRequiredHook(props.validations)
    const key = props.columnName
    const parentShowControl = get(formData, props.showOnKey)
    const fieldValue = get(formData, key)
    const [initFormData, setInitFormData] = useState(formData)

    useEffect(() => {
        if (props.validations && props.validations.length) {
            updateValidation(key, props.validations)
            for (let i = 0; i < props.validations.length; i++) {
                const validationObj = props.validations[i]
                if (validationObj.type.toLowerCase() === 'validateonblur')
                    setValidateOnBlur(true)
            }
            // if (props.setRequiredKey && fieldValue){ updateDynamicFieldValidation(fieldValue)}
        }
        if (props.customComponentValidation) {
            props.customComponentValidation.forEach(element => {
                //console.log("element",element);
                updateValidation(element.key, element.validations)
                // updateFormData(element.key, '')
            })
        }
    }, [])

    useEffect(() => {
        if (props.showOnKey) {
            internalCheckToShow(props)
        }
    }, [parentShowControl])

    useEffect(() => {
        if (props.showOnKey) {
            if (toHide[key]) {
                setToShow(false)
            } else {
                setToShow(true)
            }
        }
    }, [toHide[key]])

    useEffect(() => {
        if (props.disableOnKey) setIsDisable(checkToDisable(props, formData))
    }, [formData, props.disableForValue, props.disableOnKey])

    useEffect(() => {
        if (get(formData, key) === undefined && key !== undefined) {
            if (props.componentType === 'DatePicker') {
                updateFormData(key, null)
                return
            }
            updateFormData(key, '')
        }
    }, [])

    useEffect(() => {
        setInitFormData(formData)
        if (props.setRequiredKey && fieldValue) {
            updateDynamicFieldValidation(fieldValue)
        }
    }, [formData])

    const onBlur = () => {
        if (validateOnBlur) {
            if (props.componentType === 'DatePicker') {
                if (props.dependentKey) {
                    const dependentKeyval = getFormKeyValue(props.dependentKey)
                    if (dependentKeyval) {
                        validateForKey(key)
                        //if(errors[props.dependentKey])
                        validateForKey(props.dependentKey)
                    }
                } else validateForKey(key)
            } else validateForKey(key)
        }
    }

    const getFormKeyValue = key => get(formData, key)

    const updateDynamicFieldValidation = value => {
        if (props.setRequiredKey) {
            const updatedValidationData = _.cloneDeep(validationData)
            const fieldValidation = Array.isArray(
                updatedValidationData[props.setRequiredKey]
            )
                ? updatedValidationData[props.setRequiredKey]
                : []
            if (!props.setRequiredKeyInList) {
                if (value[props.optionIdProperty] === props.setRequiredKeyOnValue) {
                    const isReqValExists = fieldValidation.filter(
                        p => p.type === 'isRequired'
                    )
                    if (isReqValExists.length === 0) {
                        fieldValidation.push({
                            type: 'isRequired',
                            errorText: props.setRequiredKeyerrorText,
                        })
                        updateValidation(props.setRequiredKey, fieldValidation)
                    }
                } else {
                    updateValidation(
                        props.setRequiredKey,
                        fieldValidation.filter(p => p.type !== 'isRequired')
                    )
                    validateForKey(props.setRequiredKey)
                    updateErrorData(props.setRequiredKey, '')
                }
            } else {
                let isMatch = false
                const callFun = async () => {
                    await props.setRequiredKeyOnValue.forEach(v => {
                        if (props.setRequiredExcludeValue) {
                        }
                        let isMatched = value.filter(p => {
                            let valueName =
                                (p[props.optionIdProperty] &&
                                    p[props.optionIdProperty].toLowerCase()) ||
                                ''
                            let contains =
                                valueName.indexOf(v.toLowerCase()) > -1 &&
                                props.setRequiredExcludeValue &&
                                props.setRequiredExcludeValue.indexOf(v) === -1
                            return contains
                        })
                        if (isMatched.length > 0) {
                            isMatch = true
                            const isReqValExists = fieldValidation.filter(
                                p => p.type === 'isRequired'
                            )
                            if (isReqValExists.length === 0) {
                                fieldValidation.push({
                                    type: 'isRequired',
                                    errorText: props.setRequiredKeyerrorText,
                                })
                                updateValidation(props.setRequiredKey, fieldValidation)
                            }
                        }
                    })
                }
                callFun()
                if (!isMatch) {
                    updateValidation(
                        props.setRequiredKey,
                        fieldValidation.filter(p => p.type !== 'isRequired')
                    )
                    validateForKey(props.setRequiredKey)
                    updateErrorData(props.setRequiredKey, '')
                }
            }
        }
    }

    const handleChange = (value, formFieldKey = key) => {
        const currentValue = get(initFormData, formFieldKey)
        if (
            props.componentType === 'RadioSelection' &&
            currentValue === undefined &&
            value !== undefined
        ) {
            return updateFormData(formFieldKey, value)
        }

        if (props.componentType === 'CreditCardInput') {
            if (value !== null) {
                let fieldValidation = []
                fieldValidation.push({
                    type: 'isRequired',
                    errorText: value.message || 'Card details is required',
                })
                updateValidation(formFieldKey, fieldValidation)
                updateFormData(formFieldKey, null)
            } else updateFormData(formFieldKey, 'card details')
            return
        }

        if (currentValue === undefined) return
        if (typeof currentValue === 'object') {
            if (JSON.stringify(currentValue) !== JSON.stringify(value))
                setFormDataChanged(true)
        } else if (currentValue !== value) setFormDataChanged(true)
        if (typeof value === 'string')
            updateFormData(
                formFieldKey,
                value.trim().length > 0 ? value.replace(/  +/g, ' ') : ''
            )
        else updateFormData(formFieldKey, value)
        updateDynamicFieldValidation(value)
    }

    let dynamicRequired = required
    if (!required && validationData[key]) {
        const isFieldReq = validationData[key].filter(p => p.type === 'isRequired')
        dynamicRequired = isFieldReq.length > 0 ? true : false
    }

    return (
        <ComponentSelector
            {...props}
            updateFormKey={updateFormData}
            errorList={errors}
            toShow={toShow}
            fieldValue={fieldValue}
            isHide={(props.isHide && props.isHide) || false}
            onChange={handleChange}
            errorText={errors[key]}
            required={required || dynamicRequired}
            isDisable={isDisable}
            actionMethods={actionMethods}
            getFormKeyValue={getFormKeyValue}
            onBlur={onBlur}
            editMode={editMode}
        />
    )
}

export default FormBuilder
